import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';

const formatTimepunchcomercials = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        endDate: item.endDate && moment(item.endDate),
        startDate: item.startDate && moment(item.startDate),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchTimepunchcomercials,
    create: createTimepunchcomercial,
    update: updateTimepunchcomercial,
    delete: deleteTimepunchcomercials
} = createCrudActions('TIMEPUNCHCOMERCIAL', "FichajeComercial", formatTimepunchcomercials);
